/* Aravi - marketplace rating pill on product cards.

   Rotates the pills the same way the PDP pill rotates, but from ONE page-level
   timer rather than one timer per card: a collection page can hold twenty of
   these and twenty independent intervals is twenty wakeups a second on a phone.

   The pills are re-queried on each tick instead of being cached at startup, so
   cards appended later - AJAX pagination, load more, quick view - join the
   rotation on their own with no extra wiring. The query is a single
   querySelectorAll over a handful of nodes every few seconds.

   Each pill carries its own index in data-i, so the pills stay independent even
   though one timer drives them all, and a pill added mid-page starts from its
   own first item rather than jumping to wherever the others are.

   Paused while the tab is hidden. */
(function () {
  'use strict';

  var SECONDS = 3;

  function tick() {
    if (document.hidden) { return; }

    var pills = document.querySelectorAll('[data-acro-cardmp]');
    for (var n = 0; n < pills.length; n++) {
      var pill = pills[n];
      var items = pill.querySelectorAll('.acro-cardmp__item');
      if (items.length < 2) { continue; }

      var i = parseInt(pill.getAttribute('data-i'), 10);
      if (isNaN(i) || i < 0 || i >= items.length) { i = 0; }

      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
      pill.setAttribute('data-i', i);
    }
  }

  function init() {
    if (window.__acroCardMp) { return; }
    window.__acroCardMp = true;
    setInterval(tick, SECONDS * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
